import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import useDialogContext from '../../../../../../../../hooks/dialog/useDialogContext';

const AddCertificateButton = (): JSX.Element => {
  const { t } = useTranslation();
  const { openDialog } = useDialogContext();

  return (
    <Button
      className='w-full md:max-w-fit flex'
      label={t('certificatesPage.tabs.myCertificatesTab.buttons.addCertificate')}
      onClick={() => {
        openDialog('add-certificate-dialog');
      }}
    />
  );
};

export default AddCertificateButton;
